import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import BackButton from "@/components/BackButton";

/**
 * Branded 404 page. Reachable when no other route matches.
 */
export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-ink font-manrope flex items-center justify-center p-6">
      <div className="max-w-lg w-full text-center" data-testid="not-found-page">
        <div className="mb-6 flex justify-center">
          <BackButton fallback="/" />
        </div>
        <div className="text-[96px] sm:text-[120px] font-spectral text-crimson leading-none">
          404
        </div>
        <h1 className="font-spectral text-3xl tracking-tight mt-4">
          We couldn't find that page
        </h1>
        <p className="text-sm text-[#6B6B6B] mt-3 max-w-sm mx-auto leading-relaxed">
          The page may have moved, the dog may have been removed, or the link
          may simply be wrong. Let's get you back to something familiar.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2 mt-7">
          <Button asChild className="bg-[#0E0E0E] hover:bg-[#C1272D] text-white rounded-full h-10 px-5">
            <Link to="/" data-testid="not-found-home-link">Take me home</Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full h-10 px-5 border-[#E5E5E5]">
            <Link to="/marketplace" data-testid="not-found-marketplace-link">Browse marketplace</Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full h-10 px-5 border-[#E5E5E5]">
            <Link to="/contact" data-testid="not-found-contact-link">Contact support</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
